module.exports = __webpack_public_path__ + "static/fonts/Mont-Thin.f9f9889.eot";